module.exports = __webpack_public_path__ + "static/media/md.46c3ff59.jpg";